import { PriceRules } from "src/api/price/price-types";
export const findPriceRuleToText = (priceRuleType: string) => {
  switch (priceRuleType) {
    case PriceRules.PRICE_RULE_UNRECOGNIZED:
      return "-";
    case PriceRules.PRICE_RULE_PROVIDER:
      return "기본 요금";
    case PriceRules.PRICE_RULE_FACILITY:
      return "기본 요금";
    case PriceRules.PRICE_RULE_SPECIFIC:
      return "개별 요금";
    default:
      return "-";
  }
};
export const findPriceRuleOptionToText = (priceRuleType: string) => {
  switch (priceRuleType) {
    case PriceRules.PRICE_RULE_UNRECOGNIZED:
      return "-";
    case PriceRules.PRICE_RULE_PROVIDER:
      return "프로바이더";
    case PriceRules.PRICE_RULE_FACILITY:
      return "공용공간";
    case PriceRules.PRICE_RULE_SPECIFIC:
      return "-";
    default:
      return "-";
  }
};

export const CommonFacilityType = {
  COMMONFACILITY_UNRECOGNIZED: "COMMONFACILITY_UNRECOGNIZED",
  MEETING_ROOM: "MEETING_ROOM",
  DESK: "DESK",
  REFRESH_ROOM: "REFRESH_ROOM",
} as const;

export const weekDays = [
  { label: "월", value: "MON" },
  { label: "화", value: "TUE" },
  { label: "수", value: "WED" },
  { label: "목", value: "THU" },
  { label: "금", value: "FRI" },
  { label: "토", value: "SAT" },
  { label: "일", value: "SUN" },
];

/**
 * 요일 배열을 weekDays 순서대로 정렬하고 label로 변환
 * 모든 요일(월~일)이 포함되어 있으면 '전체' 반환
 */
export const formatDayOfWeekList = (dayOfWeekList: string[] | null | undefined): string => {
  if (!dayOfWeekList || !Array.isArray(dayOfWeekList) || dayOfWeekList.length === 0) {
    return "-";
  }

  // 모든 요일이 포함되어 있는지 확인
  const allWeekDayValues = weekDays.map((day) => day.value);
  const hasAllDays = allWeekDayValues.every((value) => dayOfWeekList.includes(value));

  if (hasAllDays) {
    return "전체";
  }

  // weekDays의 순서대로 정렬
  const sorted = [...dayOfWeekList].sort((a, b) => {
    const indexA = weekDays.findIndex((day) => day.value === a);
    const indexB = weekDays.findIndex((day) => day.value === b);
    // 찾지 못한 경우는 뒤로
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    return indexA - indexB;
  });

  // label로 변환
  const labels = sorted
    .map((item: string) => {
      const weekDay = weekDays.find((day) => day.value === item);
      return weekDay ? weekDay.label : item;
    })
    .join(", ");

  return labels;
};
